module.exports = fox => {
	const isAllowedMethod = require('./mixins/isAllowed')(fox);

	fox.registerWidget('LiveshowNotificationBanner', fox.mixin({
		configure() {
			this.registerOptions('', {
				template: 'liveshow_notification_banner',
				manualRender: true,
				embed: {
					container: '#liveshow-notification-container',
					widget: '@root'
				},
				handleDom: {
					close: {
						target: ['#close-upgrade-banner', '#pulldown-upgrade-banner'],
						callback: () => this.hide()
					},
					requestPrivate: {
						target: '#request-private',
						callback: () => this._requestPrivate()
					}
				},
				handleWom: {
					onLayoutChanged: {
						event: 'addedToDom',
						widget: '@root .Site_Layout',
						callback: () => this.isEmbedded() && setTimeout(() => {
							this._bindData.position = `-${this._getBannerYPos()}px`;
						}, 1005)
					},
					newSettingsRecieved: {
						widget: '@root #socket',
						event: 'inboxSocketEventLiveshow:newSettings',
						callback: (settings) => {
							if (!this.isEmbedded())
								return false;

							if (settings.answer)
								settings = settings.answer;

							const { thumbnail, privateShowRequest, allowedGroups = [] } = settings;

							this.setThumbnail(thumbnail);
							this._bindData.showJoinButton = !this._bindData.isPremiumMember &&
								!this.isAllowed(allowedGroups) &&
								allowedGroups.length;
						}
					},
					liveshowPageInDom: {
						widget: '@root ~.SitePage_Liveshow',
						event: 'addedToDom',
						callback: () => {
							if (this.__isPrivateRequest)
								return false;

							return this.hide();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		prepareEmbeddedWidgets() {
			this._bindData = {
				position: '100%',
				transitionDuration: 400,

				thumbnail: '',
				showPrivateRequestBtn: false,
				showJoinButton: !this.rwom1('@root #permissionManager').hasAccess('member'),
				isPremiumMember: this.rwom1('@root #permissionManager').hasAccess('member')
			}

			this.bindTemplateVariables(this._bindData, [
				'position',
				'transitionDuration',
				'thumbnail',
				'isPremiumMember',
				'showPrivateRequestBtn',
				'showJoinButton'
			]);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},

		_getBannerYPos() {
			const anotherBanners = fox.dom.select('.upbs-wrapper');
			const myNode = this.dom1('.upbs-wrapper');

			if (anotherBanners.length)
				return anotherBanners.reduce((acc, bannerNode) => {
					if (bannerNode === myNode)
						return acc;

					return acc + bannerNode.clientHeight
				}, 2);

			return 0;
		},

		_requestPrivate() {
			this.__isPrivateRequest = true;

			fox.site.gotoPage('liveshow');

			const promise = fox.Promise.all([
				this.wait('@root ~.ClientLSTranslator', 'app_initialized'),
				this.wait('@root ~.ClientLSTranslator #sidebarMain', 'addedToDom').then(resp => {
					return new fox.Promise(resolve => setTimeout(() => resolve(resp), 400))
				})
			]);
	
			return promise.then(([{ performer: translator }]) => {
				this.hide();

				return translator.showPaidConfirm().then(({ performer: confirmWidget }) => ({
					translator,
					confirmWidget
				}));
			}).then(({ translator, confirmWidget }) => {
				return translator.privateShowConfirmed(
					confirmWidget.rdom1('#confirm-paid'),
					'alias',
					confirmWidget
				);
			});
		},

		_getLiveshowData() {
			const api = this.getApi('__getLiveshowDataApi', {
				method: 'Liveshow.getStarted',
				sendTimezone: true
			});

			return api.psend().then(({ params }) => {
				const {
					thumbnail,
					privateShowRequest,
					allowedGroups,
					addVars: {
						private: privateShow,
						paid: paidShow
					} = {}
				} = fox.objectGet(params, 'answer.response');

				return {
					thumbnail,
					privateShowRequest,
					allowedGroups,
					isPaidShow: !!privateShow || !!paidShow
				};
			});
		},

		setThumbnail(thumbnail = '') {
			if (fox.isEmpty(thumbnail))
				return this._bindData.thumbnail = '';

			return this._bindData.thumbnail = thumbnail;
		},

		show() {
			const { alias: page } = fox.site.page;

			if (this.isEmbedded() || page === 'liveshow')
				return false;

			const yPos = this._getBannerYPos();

			this.wait('addedToDom').then(() => setTimeout(() => {
				this._bindData.position = `-${yPos}px`;
			}, 100));

			this.__shouldEmbed = true;
			this.render();

			this._getLiveshowData().then(({
				thumbnail,
				isPaidShow,
				privateShowRequest,
				allowedGroups = []
			}) => {
				this.setThumbnail(thumbnail);
				this._bindData.showPrivateRequestBtn = !isPaidShow && !!privateShowRequest;
				this._bindData.isPremiumMember = this.rwom1('@root #permissionManager').hasAccess('member');
				this._bindData.showJoinButton = !this._bindData.isPremiumMember &&
					!this.isAllowed(allowedGroups) &&
					allowedGroups.length;
			});
		},

		hide() {
			delete this.__isPrivateRequest;

			this._bindData.position = '100%';

			setTimeout(
				() => {
					this.setThumbnail();
					this.removeFromDom();
				},
				this._bindData.transitionDuration + 100
			);
		},

		beforeEmbed() {
			if (this.__shouldEmbed) {
				this.__shouldEmbed = false;
				return this.callParent('beforeEmbed', arguments);
			}

			return false;
		}
	}, isAllowedMethod));
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/NotificationBanner.es.js